/**
 * Common — Styled Components shared across features
 */
import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.97); }
  to   { opacity: 1; transform: scale(1); }
`

export const ConfirmOverlay = styled.div`position: fixed; inset: 0; background: rgba(0,0,0,0.35); backdrop-filter: blur(2px); z-index: 10000; display: flex; align-items: center; justify-content: center;`
export const ConfirmBox = styled.div`background: white; border-radius: 12px; padding: 24px; width: 340px; box-shadow: 0 20px 60px rgba(0,0,0,0.2); animation: ${fadeIn} 0.18s ease; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;`
export const ConfirmTitle = styled.div`font-size: 14px; font-weight: 700; color: #1B2A4A; margin-bottom: 8px;`
export const ConfirmMessage = styled.div`font-size: 13px; color: #6B7280; line-height: 1.5; margin-bottom: 20px;`
export const ConfirmActions = styled.div`display: flex; justify-content: flex-end; gap: 8px;`
export const ConfirmCancelBtn = styled.button`padding: 7px 16px; border: 1px solid #E5E7EB; border-radius: 7px; background: white; font-size: 13px; font-weight: 500; color: #374151; cursor: pointer; font-family: inherit; transition: all 0.15s; &:hover { background: #F9FAFB; border-color: #D1D5DB; }`
export const ConfirmOkBtn = styled.button<{ $variant?: 'default' | 'destructive' }>`
  padding: 7px 16px; border: none; border-radius: 7px; color: white;
  font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; transition: all 0.15s;
  ${({ $variant }) => $variant === 'destructive'
    ? css`background: #DC2626; &:hover { background: #B91C1C; }`
    : css`background: #007aff; &:hover { background: #0064d1; }`}
`
